<template>
	<button type="button"
	        class="category-button"
	        :class="{active: !!value}"
	        @click="$emit('input', !value)"
	>
		<slot/>
	</button>
</template>

<script>
export default {
	name: "CategoryButton",
	props: {
		value: {type: Boolean, default: false}
	}
}
</script>

